"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _excluded = ["keyPair"],
  _excluded2 = ["walletUrl"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectedMeteorWalletAccount = exports.MeteorWallet = void 0;
var near_api_js_1 = require("near-api-js");
// import { Action, createTransaction, Transaction } from "near-api-js/lib/transaction";
var ExternalActionTypes_1 = require("../../meteor-common/src/models/external_actions/ExternalActionTypes");
var borsh_1 = require("borsh");
var StringUtils_1 = require("../../meteor-common/src/utils/StringUtils");
// import { PublicKey } from "near-api-js/lib/utils";
var EnvironmentStorageUtils_1 = require("../../meteor-common/src/utils/EnvironmentStorageUtils");
var TransactionSchema_1 = require("./near-schema/TransactionSchema");
var MeteorSdkUtils_1 = require("./utils/MeteorSdkUtils");
var MeteorPostMessenger_1 = require("./postMessage/MeteorPostMessenger");
var LOGIN_WALLET_URL_SUFFIX = "/login/";
var SIGN_WALLET_URL_SUFFIX = "/sign/";
var MULTISIG_HAS_METHOD = "add_request_and_confirm";
var LOCAL_STORAGE_KEY_SUFFIX = "_meteor_wallet_auth_key";
var PENDING_ACCESS_KEY_PREFIX = "pending_key"; // browser storage key for a pending access key (i.e. key has been generated but we are not sure it was added yet)
var localStorageAdapter = new EnvironmentStorageUtils_1.EnvironmentStateAdapter_Sync({
  getString: function getString(key) {
    return window.localStorage.getItem(key);
  },
  setString: function setString(key, value) {
    return window.localStorage.setItem(key, value);
  },
  clear: function clear(key) {
    return window.localStorage.removeItem(key);
  }
});
var sessionAdapter = new EnvironmentStorageUtils_1.EnvironmentStateAdapter_Sync({
  getString: function getString(key) {
    return window.sessionStorage.getItem(key);
  },
  setString: function setString(key, value) {
    return window.sessionStorage.setItem(key, value);
  },
  clear: function clear(key) {
    return window.sessionStorage.removeItem(key);
  }
});
/**
 * This class is used in conjunction with `near-api-js` and `BrowserLocalStorageKeyStore`.
 * It directs users to the Meteor Extension or (if not available) a popup of the Meteor Wallet website for key management.
 *
 * @example
 * ```js
 * import { MeteorWallet } from "@meteorwallet/sdk";
 *
 * // create new MeteorWallet instance (passing in your initialized Near connection)
 * const meteorWallet = new MeteorWallet({ near: connectedNear, appKeyPrefix: 'my-app' });
 *
 * // -- or -- (for a quick and default Near connection config)
 * const meteorWallet = MeteorWallet.init({ networkId: "testnet" });
 *
 * // If not signed in, start the sign-in flow with Meteor Wallet.
 * // Keys will be stored in the BrowserLocalStorageKeyStore
 * if(!meteorWallet.isSignedIn()) {
 *   const { accountId } = await meteorWallet.requestSignIn();
 * }
 * ```
 */
var MeteorWallet = /*#__PURE__*/function () {
  /**
   * Construct MeteorWallet. If you'd a quick and default way, you can also use {@link MeteorWallet.init}
   *
   * @example
   * ```js
   * // create new MeteorWallet instance (passing in your initialized Near connection)
   * const meteorWallet = new MeteorWallet({ near: connectedNear, appKeyPrefix: 'my-app' });
   *
   * if(!meteorWallet.isSignedIn()) {
   *   const { accountId } = await meteorWallet.requestSignIn();
   * }
   * ```
   */
  function MeteorWallet(_a) {
    _classCallCheck(this, MeteorWallet);
    var _b, _c;
    var near = _a.near,
      _a$appKeyPrefix = _a.appKeyPrefix,
      appKeyPrefix = _a$appKeyPrefix === void 0 ? (_b = near.config.contractName) !== null && _b !== void 0 ? _b : "default" : _a$appKeyPrefix;
    /** @hidden */
    this._initializationPromises = [];
    this._near = near;
    var authDataKey = appKeyPrefix + LOCAL_STORAGE_KEY_SUFFIX;
    this._authDataKey = authDataKey;
    this._authData = (_c = localStorageAdapter.getJson(authDataKey)) !== null && _c !== void 0 ? _c : {
      allKeys: []
    };
    this._networkId = near.config.networkId;
    this._walletBaseUrl = near.config.walletUrl;
    this._keyStore = near.connection.signer.keyStore;
    /*
    console.log("Initialized wallet- checking if signed in");
          if (!this.isSignedIn()) {
      console.log("Completing sign-in process, if its available");
      this._initializationPromises.push(this._completeSignInWithAccessKey());
    }*/
  }
  /**
   * The easiest way to set up the SDK. Returns an instance of MeteorWallet, automatically connected to the Near API.
   *
   * If you need more control over the Near Network configuration- rather use {@link MeteorWallet:constructor}
   *
   * @example
   * ```js
   * const wallet = await MeteorWallet.init({ networkId: "testnet" });
   * ```
   */
  _createClass(MeteorWallet, [{
    key: "isExtensionInstalled",
    value:
    /* async initialize() {
       await Promise.all(this._initializationPromises);
     }*/
    function isExtensionInstalled() {
      return window.meteorWallet != null;
    }
    /**
     * Returns true, if this app is authorized with an account in the wallet.
     * @example
     * ```js
     * const wallet = new MeteorWallet({ near: connectedNear, appKeyPrefix: 'my-app' });
     * wallet.isSignedIn();
     * ```
     */
  }, {
    key: "isSignedIn",
    value: function isSignedIn() {
      return !!this._authData.accountId;
    }
    /**
     * Returns authorized Account ID.
     * @example
     * ```js
     * const wallet = new MeteorWallet(near, 'my-app');
     * const accountId = wallet.getAccountId();
     * ```
     */
  }, {
    key: "getAccountId",
    value: function getAccountId() {
      return this._authData.accountId;
    }
    /**
     * Verifies that the user is the owner of a specific Near account, available in the wallet.
     * Removes the need to do blockchain operations for simple Dapp actions.
     * Signs a payload with the wallet's private key. Will return a promise with a payload like so:
     *
     * ```ts
     * interface VerifiedOwner {
     *   accountId: string;
     *   message: string;                 // The same passed message, unencrypted
     *   blockId: string;
     *   publicKey: string;               // The public key which should be verified as belonging to this account
     *   signature: string;               // The signed payload (this exact same object JSON stringified, excluding this "signature" property)
     *   keyType: utils.key_pair.KeyType; // Type from inside the near-api-js package
     * }
     * ```
     *
     * or throw a {@link MeteorActionError} error if the verification failed for whatever reason.
     * */
  }, {
    key: "verifyOwner",
    value: function () {
      var _verifyOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var _a, accountId, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              accountId = (_a = options.accountId) !== null && _a !== void 0 ? _a : this.getAccountId();
              _context.next = 3;
              return (0, MeteorPostMessenger_1.getMeteorPostMessenger)().connectAndWaitForResponse({
                actionType: ExternalActionTypes_1.EWalletExternalActionType.verify_owner,
                inputs: {
                  accountId: accountId,
                  message: options.message
                },
                network: this._networkId
              });
            case 3:
              response = _context.sent;
              if (!response.success) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", response);
            case 8:
              throw new ExternalActionTypes_1.MeteorActionError({
                endTags: response.endTags,
                message: response.message
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function verifyOwner(_x) {
        return _verifyOwner.apply(this, arguments);
      }
      return verifyOwner;
    }()
    /**
     * Requests a sign-in using Meteor Wallet. Will return a promise with the `accountId` of the
     * signed-in account, or throw a {@link MeteorActionError} error if the sign-in failed for whatever reason.
     * */
  }, {
    key: "requestSignIn",
    value: function () {
      var _requestSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
        var keyPair, restOptions, accessKey, usingPublicKey, response, _response$payload, allKeys, accountId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              keyPair = options.keyPair, restOptions = _objectWithoutProperties(options, _excluded);
              accessKey = keyPair !== null && keyPair !== void 0 ? keyPair : near_api_js_1.KeyPair.fromRandom("ed25519");
              usingPublicKey = accessKey.getPublicKey().toString();
              _context2.next = 5;
              return (0, MeteorPostMessenger_1.getMeteorPostMessenger)().connectAndWaitForResponse({
                actionType: ExternalActionTypes_1.EWalletExternalActionType.login,
                inputs: _objectSpread({
                  public_key: usingPublicKey
                }, restOptions),
                network: this._networkId
              });
            case 5:
              response = _context2.sent;
              if (!response.success) {
                _context2.next = 15;
                break;
              }
              _response$payload = response.payload, allKeys = _response$payload.allKeys, accountId = _response$payload.accountId;
              this._authData = {
                accountId: accountId,
                allKeys: allKeys,
                signedInContract: {
                  contract_id: restOptions.contract_id,
                  public_key: usingPublicKey
                }
              };
              localStorageAdapter.setJson(this._authDataKey, this._authData);
              _context2.next = 12;
              return this._keyStore.setKey(this._networkId, accountId, accessKey);
            case 12:
              return _context2.abrupt("return", {
                success: true,
                endTags: [],
                payload: {
                  accessKey: accessKey,
                  accountId: accountId
                }
              });
            case 15:
              throw new ExternalActionTypes_1.MeteorActionError({
                endTags: response.endTags,
                message: response.message
              });
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function requestSignIn(_x2) {
        return _requestSignIn.apply(this, arguments);
      }
      return requestSignIn;
    }()
    /**
     * Sign out from the current account
     */
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var accountId, inputs, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              accountId = this.getAccountId();
              if (!(this._authData.signedInContract != null && accountId != null)) {
                _context3.next = 6;
                break;
              }
              inputs = {
                accountId: accountId,
                contractInfo: this._authData.signedInContract
              };
              _context3.next = 5;
              return (0, MeteorPostMessenger_1.getMeteorPostMessenger)().connectAndWaitForResponse({
                actionType: ExternalActionTypes_1.EWalletExternalActionType.logout,
                inputs: inputs,
                network: this._networkId
              });
            case 5:
              response = _context3.sent;
            case 6:
              this._authData = {
                allKeys: []
              };
              localStorageAdapter.clear(this._authDataKey);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function signOut() {
        return _signOut.apply(this, arguments);
      }
      return signOut;
    }()
    /**
     * Sign transactions using Meteor Wallet. Will return a promise with an array of `FinalExecutionOutcome`
     * of the given transactions.
     * */
  }, {
    key: "requestSignTransactions",
    value: function () {
      var _requestSignTransactions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(inputs) {
        var transactions, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              transactions = inputs.transactions;
              _context4.next = 3;
              return (0, MeteorPostMessenger_1.getMeteorPostMessenger)().connectAndWaitForResponse({
                actionType: ExternalActionTypes_1.EWalletExternalActionType.sign,
                inputs: {
                  transactions: transactions.map(function (transaction) {
                    return (0, borsh_1.serialize)(TransactionSchema_1.SCHEMA, transaction);
                  }).map(function (serialized) {
                    return Buffer.from(serialized).toString("base64");
                  }).join(",")
                },
                // inputs: { public_key: usingPublicKey, ...options },
                network: this._networkId
              });
            case 3:
              response = _context4.sent;
              if (!response.success) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", response.payload.executionOutcomes);
            case 8:
              throw new ExternalActionTypes_1.MeteorActionError({
                endTags: response.endTags,
                message: response.message
              });
            case 9:
              return _context4.abrupt("return", []);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function requestSignTransactions(_x3) {
        return _requestSignTransactions.apply(this, arguments);
      }
      return requestSignTransactions;
    }()
    /**
     * Returns the current connected wallet account
     */
  }, {
    key: "account",
    value: function account() {
      var currentAccountId = this.getAccountId();
      if (!this._connectedAccount && (0, StringUtils_1.notNullEmpty)(currentAccountId)) {
        this._connectedAccount = new ConnectedMeteorWalletAccount(this, this._near.connection, currentAccountId);
      }
      return this._connectedAccount;
    }
  }], [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref) {
        var walletUrl, config, keyStore, near, wallet;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              walletUrl = _ref.walletUrl, config = _objectWithoutProperties(_ref, _excluded2);
              keyStore = new near_api_js_1.keyStores.BrowserLocalStorageKeyStore();
              _context5.next = 4;
              return (0, near_api_js_1.connect)(_objectSpread(_objectSpread({
                keyStore: keyStore,
                headers: {},
                walletUrl: (0, MeteorSdkUtils_1.resolveWalletUrl)(config.networkId, walletUrl)
              }, (0, MeteorSdkUtils_1.getNetworkPreset)(config.networkId)), config));
            case 4:
              near = _context5.sent;
              wallet = new MeteorWallet({
                near: near,
                appKeyPrefix: "near_app"
              }); // Cleanup up any pending keys (cancelled logins).
              if (wallet.isSignedIn()) {
                _context5.next = 9;
                break;
              }
              _context5.next = 9;
              return keyStore.clear();
            case 9:
              return _context5.abrupt("return", wallet);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function init(_x4) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
  return MeteorWallet;
}();
exports.MeteorWallet = MeteorWallet;
/**
 * Near Account implementation which makes use of {@link MeteorWallet} when no local key is available.
 *
 * Generally won't be created directly- can be obtained by using {@link MeteorWallet.account}
 *
 * @example
 * ```js
 * const account = meteorWallet.account();
 *
 * // uses Meteor Wallet to sign the transaction using this account
 * const response = await account.requestSignTransaction({
 *   actions: transactionActions,
 *   receiverId: "my-contract"
 * });
 * ```
 */
var ConnectedMeteorWalletAccount = /*#__PURE__*/function (_near_api_js_1$Accoun) {
  _inherits(ConnectedMeteorWalletAccount, _near_api_js_1$Accoun);
  var _super = _createSuper(ConnectedMeteorWalletAccount);
  /** @hidden */
  function ConnectedMeteorWalletAccount(walletConnection, connection, accountId) {
    var _this;
    _classCallCheck(this, ConnectedMeteorWalletAccount);
    _this = _super.call(this, connection, accountId);
    _this.meteorWallet = walletConnection;
    return _this;
  }
  /**
   * Sign a transaction using Meteor Wallet. Overrides the Near Account API method of the same name, makes use of {@link ConnectedMeteorWalletAccount.signAndSendTransaction_direct}
   */
  _createClass(ConnectedMeteorWalletAccount, [{
    key: "signAndSendTransaction",
    value: function () {
      var _signAndSendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(typeof (_args6.length <= 0 ? undefined : _args6[0]) === "string")) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return", this.signAndSendTransaction_direct({
                receiverId: _args6.length <= 0 ? undefined : _args6[0],
                actions: _args6.length <= 1 ? undefined : _args6[1]
              }));
            case 2:
              return _context6.abrupt("return", this.signAndSendTransaction_direct(_args6.length <= 0 ? undefined : _args6[0]));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function signAndSendTransaction() {
        return _signAndSendTransaction.apply(this, arguments);
      }
      return signAndSendTransaction;
    }() /** @hidden */
  }, {
    key: "trySendOrCreateTransaction",
    value: function () {
      var _trySendOrCreateTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref2) {
        var receiverId, actions, localKey, accessKey, block, blockHash, publicKey, nonce, transaction;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              receiverId = _ref2.receiverId, actions = _ref2.actions;
              _context7.next = 3;
              return this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
            case 3:
              localKey = _context7.sent;
              _context7.next = 6;
              return this.accessKeyForTransaction(receiverId, actions, localKey);
            case 6:
              accessKey = _context7.sent;
              if (accessKey) {
                _context7.next = 9;
                break;
              }
              throw new Error("Cannot find matching key for transaction sent to ".concat(receiverId));
            case 9:
              if (!(localKey && localKey.toString() === accessKey.public_key)) {
                _context7.next = 26;
                break;
              }
              _context7.prev = 10;
              _context7.next = 13;
              return _get(_getPrototypeOf(ConnectedMeteorWalletAccount.prototype), "signAndSendTransaction", this).call(this, {
                receiverId: receiverId,
                actions: actions
              });
            case 13:
              _context7.t0 = _context7.sent;
              return _context7.abrupt("return", {
                executionOutcome: _context7.t0,
                sent: true
              });
            case 17:
              _context7.prev = 17;
              _context7.t1 = _context7["catch"](10);
              if (!(_context7.t1.type === "NotEnoughAllowance")) {
                _context7.next = 25;
                break;
              }
              _context7.next = 22;
              return this.accessKeyForTransaction(receiverId, actions);
            case 22:
              accessKey = _context7.sent;
              _context7.next = 26;
              break;
            case 25:
              throw _context7.t1;
            case 26:
              _context7.next = 28;
              return this.connection.provider.block({
                finality: "final"
              });
            case 28:
              block = _context7.sent;
              blockHash = (0, borsh_1.baseDecode)(block.header.hash);
              publicKey = near_api_js_1.utils.PublicKey.from(accessKey.public_key); // TODO: Cache & listen for nonce updates for given access key
              nonce = accessKey.access_key.nonce + 1;
              transaction = near_api_js_1.transactions.createTransaction(this.accountId, publicKey, receiverId, nonce, actions, blockHash);
              return _context7.abrupt("return", {
                sent: false,
                transaction: transaction
              });
            case 34:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[10, 17]]);
      }));
      function trySendOrCreateTransaction(_x5) {
        return _trySendOrCreateTransaction.apply(this, arguments);
      }
      return trySendOrCreateTransaction;
    }()
    /**
     * Sign a transaction using Meteor Wallet
     * @see {@link MeteorWallet.requestSignTransactions}
     */
  }, {
    key: "signAndSendTransaction_direct",
    value: function () {
      var _signAndSendTransaction_direct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref3) {
        var receiverId, actions, _yield$this$trySendOr, transaction, sent, executionOutcome;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              receiverId = _ref3.receiverId, actions = _ref3.actions;
              _context8.next = 3;
              return this.trySendOrCreateTransaction({
                receiverId: receiverId,
                actions: actions
              });
            case 3:
              _yield$this$trySendOr = _context8.sent;
              transaction = _yield$this$trySendOr.transaction;
              sent = _yield$this$trySendOr.sent;
              executionOutcome = _yield$this$trySendOr.executionOutcome;
              if (!sent) {
                _context8.next = 9;
                break;
              }
              return _context8.abrupt("return", executionOutcome);
            case 9:
              _context8.next = 11;
              return this.meteorWallet.requestSignTransactions({
                transactions: [transaction]
              });
            case 11:
              return _context8.abrupt("return", _context8.sent[0]);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function signAndSendTransaction_direct(_x6) {
        return _signAndSendTransaction_direct.apply(this, arguments);
      }
      return signAndSendTransaction_direct;
    }()
    /** @hidden */
    /*async signAndSendTransaction_redirect({
      receiverId,
      actions,
      walletMeta,
      walletCallbackUrl = window.location.href,
    }: SignAndSendTransactionOptions): Promise<FinalExecutionOutcome> {
      const { transaction, sent, executionOutcome } = await this.trySendOrCreateTransaction({ receiverId, actions });
          if (sent) {
        return executionOutcome!;
      }
          await this.meteorWallet.requestSignTransactions_redirect({
        transactions: [transaction!],
        meta: walletMeta,
        callback_url: walletCallbackUrl,
      });
          return new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error("Failed to redirect to sign transaction"));
        }, 1000);
      });
    }*/
    /**
     * Check if given access key allows the function call or method attempted in transaction
     * @param accessKey Array of {access_key: AccessKey, public_key: PublicKey} items
     * @param receiverId The NEAR account attempting to have access
     * @param actions The action(s) needed to be checked for access
     */
  }, {
    key: "accessKeyMatchesTransaction",
    value: function () {
      var _accessKeyMatchesTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(accessKey, receiverId, actions) {
        var permission, _permission$FunctionC, allowedReceiverId, allowedMethods, _actions, functionCall;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              permission = accessKey.access_key.permission;
              if (!(permission === "FullAccess")) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", true);
            case 3:
              if (!permission.FunctionCall) {
                _context9.next = 12;
                break;
              }
              _permission$FunctionC = permission.FunctionCall, allowedReceiverId = _permission$FunctionC.receiver_id, allowedMethods = _permission$FunctionC.method_names;
              /********************************
               Accept multisig access keys and let wallets attempt to signAndSendTransaction
               If an access key has itself as receiverId and method permission add_request_and_confirm, then it is being used in a wallet with multisig contract: https://github.com/near/core-contracts/blob/671c05f09abecabe7a7e58efe942550a35fc3292/multisig/src/lib.rs#L149-L153
               ********************************/
              if (!(allowedReceiverId === this.accountId && allowedMethods.includes(MULTISIG_HAS_METHOD))) {
                _context9.next = 7;
                break;
              }
              return _context9.abrupt("return", true);
            case 7:
              if (!(allowedReceiverId === receiverId)) {
                _context9.next = 12;
                break;
              }
              if (!(actions.length !== 1)) {
                _context9.next = 10;
                break;
              }
              return _context9.abrupt("return", false);
            case 10:
              _actions = _slicedToArray(actions, 1), functionCall = _actions[0].functionCall;
              return _context9.abrupt("return", functionCall && (!functionCall.deposit || functionCall.deposit.toString() === "0") && (
              // TODO: Should support charging amount smaller than allowance?
              allowedMethods.length === 0 || allowedMethods.includes(functionCall.methodName)));
            case 12:
              return _context9.abrupt("return", false);
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function accessKeyMatchesTransaction(_x7, _x8, _x9) {
        return _accessKeyMatchesTransaction.apply(this, arguments);
      }
      return accessKeyMatchesTransaction;
    }()
    /**
     * Helper function returning the access key (if it exists) to the receiver that grants the designated permission
     * @param receiverId The NEAR account seeking the access key for a transaction
     * @param actions The action(s) sought to gain access to
     * @param localKey A local public key provided to check for access
     * @returns Promise<any>
     */
  }, {
    key: "accessKeyForTransaction",
    value: function () {
      var _accessKeyForTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(receiverId, actions, localKey) {
        var accessKeys, accessKey, walletKeys, _iterator, _step, _accessKey;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.getAccessKeys();
            case 2:
              accessKeys = _context10.sent;
              if (!localKey) {
                _context10.next = 12;
                break;
              }
              accessKey = accessKeys.find(function (key) {
                return key.public_key.toString() === localKey.toString();
              });
              _context10.t0 = accessKey;
              if (!_context10.t0) {
                _context10.next = 10;
                break;
              }
              _context10.next = 9;
              return this.accessKeyMatchesTransaction(accessKey, receiverId, actions);
            case 9:
              _context10.t0 = _context10.sent;
            case 10:
              if (!_context10.t0) {
                _context10.next = 12;
                break;
              }
              return _context10.abrupt("return", accessKey);
            case 12:
              walletKeys = this.meteorWallet._authData.allKeys;
              _iterator = _createForOfIteratorHelper(accessKeys);
              _context10.prev = 14;
              _iterator.s();
            case 16:
              if ((_step = _iterator.n()).done) {
                _context10.next = 27;
                break;
              }
              _accessKey = _step.value;
              _context10.t1 = walletKeys.indexOf(_accessKey.public_key) !== -1;
              if (!_context10.t1) {
                _context10.next = 23;
                break;
              }
              _context10.next = 22;
              return this.accessKeyMatchesTransaction(_accessKey, receiverId, actions);
            case 22:
              _context10.t1 = _context10.sent;
            case 23:
              if (!_context10.t1) {
                _context10.next = 25;
                break;
              }
              return _context10.abrupt("return", _accessKey);
            case 25:
              _context10.next = 16;
              break;
            case 27:
              _context10.next = 32;
              break;
            case 29:
              _context10.prev = 29;
              _context10.t2 = _context10["catch"](14);
              _iterator.e(_context10.t2);
            case 32:
              _context10.prev = 32;
              _iterator.f();
              return _context10.finish(32);
            case 35:
              return _context10.abrupt("return", null);
            case 36:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[14, 29, 32, 35]]);
      }));
      function accessKeyForTransaction(_x10, _x11, _x12) {
        return _accessKeyForTransaction.apply(this, arguments);
      }
      return accessKeyForTransaction;
    }()
  }]);
  return ConnectedMeteorWalletAccount;
}(near_api_js_1.Account);
exports.ConnectedMeteorWalletAccount = ConnectedMeteorWalletAccount;